export default "__VITE_ASSET__BlRSaLc9__"